import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { SessionService } from '../session/session.service';
import { UserType } from 'sp-client';

export const adminGuard: CanActivateFn = (): boolean | UrlTree => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  const user = sessionService.user();
  
  if (user === undefined) {
    return router.createUrlTree(['/login']);
  }

  if (user.user_type_id !== UserType.BackendAdmin) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
}; 